import full_calendar from './fullCalendar.vue'

export default full_calendar;


// WEBPACK FOOTER //
// ./src/components/customComponents/fullCalendar/index.js